import MuiCheckbox from './MuiCheckbox';
import MuiTabs from './MuiTabs';
import MuiSwitch from './MuiSwitch';
import MuiButtonBase from './MuiButtonBase';

export default {
  MuiSwitch,
  MuiTabs,
  MuiCheckbox,
  MuiButtonBase,
};
